export default "<Label class=\"app-bot-link\" text=\"Hello AppBotLinkComponent!\"></Label>"